import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { HStack } from "@design-system/HStack/HStack";
import styles from "../CoaMappingDrawer.module.scss";

interface Props {
    totalAccountCount: number;
    confirmLabel: string;
    isConfirming: boolean;
    onBack: () => void;
    onConfirm: () => void;
}

export const CoaMappingPreviewIsland = ({
    totalAccountCount,
    confirmLabel,
    isConfirming,
    onBack,
    onConfirm,
}: Props) => (
    <CommandIsland sticky>
        <div className={styles.accountCounts}>
            <span>Total accounts: {totalAccountCount}</span>
        </div>
        <HStack gap={8} align="center" className="ml-auto">
            <Button
                variant="secondary"
                size="md"
                onClick={onBack}
                disabled={isConfirming}
            >
                Back
            </Button>
            <ButtonWithLoader
                variant="primary"
                size="md"
                loading={isConfirming}
                hotKey="mod+enter"
                hotKeyOptions={{ description: confirmLabel }}
                hotKeyDisplayPosition="inline"
                onClick={onConfirm}
            >
                {confirmLabel}
            </ButtonWithLoader>
        </HStack>
    </CommandIsland>
);
